import React from 'react';
import SvgIcon from '@material-ui/core/SvgIcon';

const Fac = props => (
  <SvgIcon {...props} viewBox="0 0 1024 1024 ">
    <path d="M512.935 0L0 512L512.888 1024L1024 512L512.935 0Z" />
  </SvgIcon>
);

export default Fac;
